import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const LAUNCH_DATE = '2026-06-02';

const isLaunchPeriod = () => {
  const launch = new Date(LAUNCH_DATE + 'T00:00:00');
  const diff = (new Date() - launch) / (1000 * 60 * 60 * 24);
  return diff >= 0 && diff <= 30;
};

function LaunchSplash() {
  return (
    <div className="min-h-screen bg-[#0c1524] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1e3a5f]/35 via-[#0c1524] to-[#080d16] flex flex-col items-center justify-center relative overflow-hidden">
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, type: 'spring', stiffness: 140, damping: 16 }}
        className="relative z-10"
      >
        <img src={logo} alt="Lucy Garden" className="w-20 h-20 rounded-2xl object-cover shadow-2xl ring-1 ring-white/15" />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.35, duration: 0.4 }}
        className="text-2xl font-black text-white mt-5 tracking-tight relative z-10"
      >
        Lucy Garden
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="text-[#94a3b8] text-[11px] font-bold tracking-[0.2em] uppercase mt-1 relative z-10"
      >
        Fresh Dairy Supply
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="mt-5 px-4 py-2 rounded-xl bg-white/5 border border-white/10 relative z-10"
      >
        <p className="text-[11px] text-blue-200/80 font-semibold text-center">
          Your Digital Fresh Dairy Partner
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="mt-8 relative z-10 w-28"
      >
        <div className="h-[2.5px] bg-white/10 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: '0%' }}
            animate={{ width: '100%' }}
            transition={{ delay: 1.2, duration: 1.2, ease: 'easeInOut' }}
            className="h-full bg-blue-400 rounded-full"
          />
        </div>
      </motion.div>
    </div>
  );
}

function NormalSplash() {
  return (
    <div className="min-h-screen bg-[#0c1524] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1e3a5f]/30 via-[#0c1524] to-[#080d16] flex flex-col items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.35 }}
        className="relative z-10"
      >
        <img src={logo} alt="Lucy Garden" className="w-16 h-16 rounded-2xl object-cover shadow-xl ring-1 ring-white/15" />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.15 }}
        className="text-xl font-bold text-white mt-4 tracking-tight"
      >
        Lucy Garden
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.25 }}
        className="text-[#94a3b8] text-[10px] font-bold tracking-[0.2em] uppercase mt-1"
      >
        Fresh Dairy Supply
      </motion.p>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.35 }}
        className="mt-6 w-20"
      >
        <div className="h-[2.5px] bg-white/10 rounded-full overflow-hidden">
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{ duration: 1, repeat: Infinity, ease: 'easeInOut' }}
            className="h-full w-1/2 bg-gradient-to-r from-transparent via-blue-400 to-transparent"
          />
        </div>
      </motion.div>
    </div>
  );
}

export default function SplashScreen() {
  return isLaunchPeriod() ? <LaunchSplash /> : <NormalSplash />;
}
